import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

export interface ArchivedFile {
  name: string
  size: number
  created: string
  updated: string
}

export function useArchivedFiles() {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<ArchivedFile[]>>(
    token ? '/api/audit-logs/archive/files' : null,
    undefined,
    token ?? '',
  )

  return {
    files: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
